module.exports = __webpack_public_path__ + "img/spaceman.84d81697.svg";